import React from 'react'
import { useSelector } from 'react-redux'
import { Field } from 'redux-form'
import { Row, Col } from 'flexbox'

import { SwitchForm } from 'controls/Switch'

import styles from './styles'

const Characteristics = ({
  formName,
  nameValue,
  category,
  dataTabForm,
  characteristics = [],
  title
}) => (
  <div data-gtm-form-property={dataTabForm}>
    <h3>{title}</h3>
    <Row>
      {characteristics.map(({ name, id }) => (
        <Col key={id} xs={12} md={3}>
          <div className="characteristic-container">
            <span>{name}</span>
            <Field
              component={SwitchForm}
              type="checkbox"
              name={`${nameValue}.${category}.${id}`}
            />
          </div>
        </Col>
      ))}
    </Row>
    <style jsx>{styles}</style>
  </div>
)

export default Characteristics